import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal, Box } from "@mui/material";
import { isMobile } from 'react-device-detect';

// images
import hcpMobile3En from "../assets/image/tutorial/hcp/mobile/hcpTutorial3-en.png";
import hcpDesktop3En from "../assets/image/tutorial/hcp/desktop/hcpTutorial3-en.png";
import tutorialArrow from "../assets/image/tutorialArrow.png";

const HcpTutorial3 = () => {

    const navigate = useNavigate();

    const [openTutorial, setOpenTutorial] = useState(true);

    return (
        <div>
            {
                isMobile ? (
                    <img src={hcpMobile3En} alt="hcpTutorial" style={{ height: "100vh", width: "100vw" }} />
                ) : (
                    <img src={hcpDesktop3En} alt="hcpTutorial" style={{ height: "100vh", width: "100vw" }} />
                )
            }
            <Modal
                open={openTutorial}
                onClose={() => setOpenTutorial(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                hideBackdrop={true}
            >
                <Box className="tutorial-modal-3">
                    <p style={{ fontSize: "18px" }}>Enter redemption code that sent to patient's mobile or inbox</p>
                    <img src={tutorialArrow} alt="arrow" style={{ float: "right" }} onClick={() => navigate('/hcp/hcpTutorial4')} />
                </Box>
            </Modal>
        </div>
    );
};

export default HcpTutorial3;
